import { useEffect, useState, useContext, useRef } from "react";
import { Link } from 'react-router-dom';

import "./my-orders.scss";

import { LayoutContext } from "../layout/";
import Loader from "../loader";
import { getEndpoint } from "../helper";

const Box = ({ id, trackingCode, payablePrice, createdAt, status, mobile, isCallingServer, setIsCallingServer, cancelOrder, activeTabIndex }) => {
    const formatNumber = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const StatusTag = () => {
        let text = '';
        let className = 'mr-a status br-999';

        if (status === 0) {
            text = 'در حال بررسی';
            className += ' pending';
        }
        else if (status === 1) {
            text = 'در انتظار پرداخت';
            className += ' awaiting-payment';
        }
        else if (status === 2) {
            text = 'در حال آماده سازی';
            className += ' preparing';
        }
        else if (status === 3) {
            text = 'ارسال شده';
            className += ' sent';
        }
        else if (status === 4) {
            text = 'تحویل شده';
            className += ' delivered';
        }
        else if (status === 5) {
            text = 'لغو شده';
            className += ' canceled';
        }
        else if (status === 6) {
            text = 'مرجوع شده';
            className += ' returned';
        }

        return (
            <div className={className}>{text}</div>
        );
    }

    return (
        <div className='box bw-1 bc--n3 bc-w br-3 p-4 mb-4'>
            <div className='d-f ai-c mb-2'>
                <div className='t'>
                    <span>شماره سفارش:</span>&nbsp;<span>{trackingCode}</span>
                </div>
                <StatusTag />
            </div>
            <div className='t'>{createdAt}</div>
            <hr className='bc--n3 my-3' />
            <div className='d-f ai-c'>
                <div className='t'>قیمت کل:</div>
                <div className='mr-a c-b fw-900' style={{ fontSize: '1.1em' }}>{formatNumber(payablePrice)}&nbsp;ریال</div>
            </div>
            <hr className='bc--n3 my-3' />
            <div className='d-f ai-c'>
                <Link to={`/order/${id}`} className='_c-g'>مشاهده جزئیات</Link>
                {activeTabIndex == 0 && <button className='mr-a _c-r f:o-n' onClick={e => cancelOrder(id)}>{isCallingServer ? 'لطفا منتظر بمانید ...' : 'لغو سفارش'}</button>}
            </div>
        </div >
    );
}

export default function MyOrders({ ...props }) {
    const { mobile, setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isCallingServer, setIsCallingServer] = useState(false);

    const controllerRef = useRef(null);

    const fetchData = async () => {
        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;

        try {
            setLoading(true);
            const response = await fetch(getEndpoint(`/api/android/order/getby?username=${mobile}`), { signal });

            const json = await response.json();
            setData(json.data);

        } catch (err) {
            if (err.name !== "AbortError") setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const cancelOrder = async id => {
        setIsCallingServer(true);

        await fetch(getEndpoint(`/api/android/order/cancel?username=${mobile}&id=${id}`));

        setIsCallingServer(false);
        fetchData();
    }

    const TabHeader = ({ title, tabIndex, activeTabIndex }) => {
        let count = 0;

        if (data.length > 0) {
            const { _0Count, _1Count, _2Count, _3Count, _4Count, _5Count, _6Count } = data[0];

            if (tabIndex == 0) count = _0Count + _1Count + _2Count + _3Count;
            else if (tabIndex == 1) count = _4Count;
            else if (tabIndex == 2) count = _5Count;
            else if (tabIndex == 3) count = _6Count;
        }

        return (
            <div className={`d-f ai-c py-3 px-2 w-25% us-n c-p ${activeTabIndex == tabIndex ? 'active' : ''}`} onClick={e => setActiveTabIndex(tabIndex)}>
                <div className='ws-nw'>{title}</div>
                {count > 0 && <div className={`c-w mr-1 ${activeTabIndex == tabIndex ? '_bc-b' : '_bc-g_g2'}`} style={{ padding: '0 .3em', fontSize: '.9em' }}>{count}</div>}
            </div>
        );
    }

    const List = () => {
        let items = data.filter(x => {
            if (activeTabIndex == 0) return [0, 1, 2, 3].indexOf(x.orderStatus) > -1;
            if (activeTabIndex == 1) return x.orderStatus == 4;
            if (activeTabIndex == 2) return x.orderStatus == 5;
            if (activeTabIndex == 3) return x.orderStatus == 6;
        });

        if (items.length === 0) {
            return (
                <div className='d-f ai-c jc-c h-100' style={{ backgroundColor: '#f5f5f5' }}>
                    <div>
                        <img className="w-9 mx-a mb-4" src={getEndpoint("/pwa/img/icons/paper2.svg")} />
                        <div>سفارش فعالی در این بخش وجود ندارد</div>
                    </div>
                </div>
            );
        }

        return (
            <div className='p-4' >
                {
                    items.map(x => (
                        <Box
                            key={x.id}
                            id={x.id}
                            trackingCode={x.trackingCode}
                            payablePrice={x.payablePrice}
                            createdAt={x.createdAt_}
                            status={x.orderStatus}
                            mobile={mobile}
                            cancelOrder={cancelOrder}
                            setIsCallingServer={setIsCallingServer}
                            isCallingServer={isCallingServer}
                            activeTabIndex={activeTabIndex}
                        />
                    ))
                }
            </div>
        );
    }

    useEffect(() => {
        setPageTitle('سفارش ها');

        fetchData();

        return () => {
            if (controllerRef.current) controllerRef.current.abort();
        };
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='h-100' style={{ backgroundColor: '#f5f5f5', paddingBottom: '6rem' }}>
            <div className='tab d-f bc-w'>
                <TabHeader title='جاری' tabIndex='0' activeTabIndex={activeTabIndex} />
                <TabHeader title='تحویل شده' tabIndex='1' activeTabIndex={activeTabIndex} />
                <TabHeader title='لغو شده' tabIndex='2' activeTabIndex={activeTabIndex} />
                <TabHeader title='مرجوع شده' tabIndex='3' activeTabIndex={activeTabIndex} />
            </div>
            <List />
        </div>
    );
}